import * as React from 'react';
import { Icon } from '../../primitives/icon/icon';
/* tslint:disable */
export var xIcon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\n<path d=\"M8.25 9L5 5.75 5.75 5 9 8.25 12.25 5l.75.75L9.75 9 13 12.25l-.75.75L9 9.75 5.75 13 5 12.25\"/>\n</svg>\n";
export var XIcon = function () { return React.createElement(Icon, { icon: xIcon }); };
//# sourceMappingURL=x.js.map